import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import MaterialGrid from '@material-ui/core/Grid';
import LoadingProgress from 'common/components/progress/loading';
import _ from 'lodash';
import AlertDialogSlide from 'common/components/dialog/dialogActivits';
import Informations from 'modules/owner/pages/actions/sections/information';
import ActionsTabs from 'common/components/navigation/actionsTab/activityTabs';
import Prize from 'modules/owner/pages/actions/sections/prize';
import Publish from 'modules/owner/pages/actions/sections/publish';
import { getFormValues } from 'redux-form';
import { imgToBase64, imgToImgType } from 'helpers/utils';
import { isMobile } from 'react-device-detect';
import { publishAction } from 'modules/owner/pages/actions/activeActions/activeActionsScripts';
import { getList as getLottiesList } from '../../lotties/lottiesActions';
import {
  submitAction,
  getDetail,
  dispatchFormReset,
  savePartialy,
} from './referralCampaignActions';
import Interaction from './sections/interaction';

function Main(props) {
  const [value, setValue] = React.useState(0);
  const [openConfirmation, setOpenConfirmation] = useState(false);

  useEffect(() => {
    props.getLottiesList();
  }, []);

  async function handleChange(values, router) {
    values.base64 = values.image.base64;
    if (!_.isUndefined(values.image.base64)) {
      values.imageType = imgToImgType(values.image);
    }

    values.type_action = 44;

    values.body = {
      ...values,
      name: values.body_name,
      description: values.body_description,
    };
    delete values.body.image;
    delete values.body.base64;
    delete values.body.imageType;
    values.body = JSON.stringify(values.body);

    const selectedVideos = [];
    selectedVideos.push({
      video_id: values.videoIdField,
      name: '',
      description: '',
      required: false,
    });
    values.videos = [...selectedVideos];

    props.savePartialy(values, router, setValue, value);
  }

  function goBack() {
    setValue(value - 1);
  }
  function handleOpenConfirmation() {
    setOpenConfirmation(true);
  }
  function handleCancelClose() {
    setOpenConfirmation(false);
  }

  function handleNativeChange(e, newValue) {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      setValue(newValue);
    } else {
      if (newValue < value) {
        setValue(newValue);
      }
    }
  }

  useEffect(() => {
    if (
      props.router.params.action === 'editar' ||
      props.router.params.action === 'proposta' ||
      props.router.params.action === 'rascunho'
    ) {
      props.getDetail(props.router.params.id);
    }
  }, []);

  const onSubmit = async (values) => {
    if (!_.isUndefined(values.image.base64)) {
      values.imageType = imgToImgType(values.image);
      values.base64 = imgToBase64(values.image);
    }

    values.station = props.auth.user.establishments[0].stations[0].id;
    values.type_action = 44;
    const target =
      values.segmentation_type === 'public'
        ? {
            age: { from: values.from, to: values.to },
            states: values.states,
            associated: values.associated,
            internal: values.internal,
            plans: values.segment_plans,
            entities: values.entities,
          }
        : { segment_users: values.segment_users };

    values.target = target;

    if (props.router.params.action === 'proposta') {
      values.sponsored = true;
      values.partner = values.partner_id;
    }

    const create_or_update =
      props.router.params.action === 'editar' ||
      props.router.params.action === 'rascunho' ||
      props.router.params.action === 'proposta'
        ? 'update'
        : 'create';
    const id_action = props.router.params.id;
    let publish = null;
    if (props.router.params.action === 'rascunho') {
      publish = () => {
        return props.publishAction(
          props.router.params.id,
          props.router,
          'referralCampaignForm',
          'REFERRAL_CAMPAIGN_BUTTON_LOAD'
        );
      };
    }

    props.submitAction(values, props.router, create_or_update, id_action, publish);
  };

  function onDialogClose() {
    props.dispatchFormReset();
    const from = props.location.query.from ? props.location.query.from : 'online';
    props.router.push(
      props.router.params.action === 'editar'
        ? `/owner/acoes/minhas-atividades?from=${from}`
        : props.router.params.action === 'rascunho'
        ? '/owner/acoes/minhas-atividades?from=drafts'
        : props.router.params.action === 'proposta'
        ? '/owner/acoes/propostas'
        : '/owner'
    );
  }

  const tabProps = {
    confirmationTitle: 'Deseja sair da edição?',
    confirmationSubtitle: 'Lembre-se, as informações que não foram salvas serão perdidas.',
    buttonConfirmationLabel: 'Sim, sair da edição',
    handleOpenConfirmation,
    handleCancelClose,
    openConfirmation,
    setOpenConfirmation,
    closeModal: onDialogClose,
    router: props.router,
  };

  return (
    <AlertDialogSlide
      label={'Indique e Concorra'}
      form={props.formValues}
      test={true}
      visible={true}
      height="95vh"
      onClose={handleOpenConfirmation}
      maxWidth={isMobile ? 'xl' : 'sm'}>
      {props.referralCampaign.status === 'pending' || props.referralCampaign.status === 'idle' ? (
        <div className="d-flex justify-content-center mt-5">
          <LoadingProgress />
        </div>
      ) : (
        <MaterialGrid
          container
          direction="column"
          justify="center"
          alignItems="stretch"
          sm={12}
          md={12}
          lg={12}>
          <ActionsTabs
            styles={{ marginBottom: 35, width: '100%' }}
            icons={[0, 2, 0, 0]}
            sectionTitles={[0, 2, 1, 0]}
            handleChange={handleNativeChange}
            onClickProgress={(values) => {
              if (values.submitFromButton) return;
              handleChange(values, props.router);
            }}
            goBack={goBack}
            activeTab={value}
            form="referralCampaignForm"
            tabs={[
              {
                content: (
                  <Informations
                    {...tabProps}
                    template={props.location.query.template}
                    type={props.location.query.type}
                    form="referralCampaignForm"
                    onClickProgress={(values) => handleChange(values, props.router)}
                    disabled={props.router.params.action === 'editar'}
                  />
                ),
                icon: 'subject',
                label: 'Informações',
              },
              {
                content: (
                  <Interaction
                    {...tabProps}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    disabled={props.router.params.action === 'editar'}
                  />
                ),
                icon: 'forum',
                label: 'Interações',
              },
              {
                content: (
                  <Prize
                    {...tabProps}
                    onClickProgress={(values) => handleChange(values, props.router)}
                    prevClick={goBack}
                    disabled={props.router.params.action === 'editar'}
                    form="referralCampaignForm"
                    hideGiveaway
                  />
                ),
                label: 'Recompensas',
                icon: 'loyalty',
              },
              {
                content: (
                  <Publish
                    {...tabProps}
                    onClickProgress={(values) => onSubmit(values)}
                    prevClick={goBack}
                    form="referralCampaignForm"
                    disabled={props.router.params.action === 'editar'}
                    nativePicker
                  />
                ),
                label: 'Publicação',
                icon: 'settings',
              },
            ]}
          />
        </MaterialGrid>
      )}
    </AlertDialogSlide>
  );
}

Main.propTypes = {
  auth: PropTypes.shape({ user: PropTypes.shape({ establishments: PropTypes.any }) }),
  dispatchFormReset: PropTypes.func,
  formValues: PropTypes.any,
  getDetail: PropTypes.func,
  getLottiesList: PropTypes.func,
  location: PropTypes.shape({
    query: PropTypes.shape({ from: PropTypes.any, template: PropTypes.any, type: PropTypes.any }),
  }),
  publishAction: PropTypes.func,
  router: PropTypes.shape({
    params: PropTypes.shape({ action: PropTypes.string, id: PropTypes.any }),
    push: PropTypes.func,
  }),
  savePartialy: PropTypes.func,
  referralCampaign: PropTypes.shape({ status: PropTypes.string }),
  submitAction: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  referralCampaign: state.referralCampaign,
  formValues: getFormValues('referralCampaignForm')(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    { submitAction, getDetail, dispatchFormReset, getLottiesList, savePartialy, publishAction },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(Main);
